import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Space } from "antd";
import SwitchLocale from "../SwitchLocale";
import UserInfo from "../UserInfo";
import useStyles from "./style";
const LayoutHeader = ({
  title,
  onEditPassword,
  onLogout,
  renderLayoutHeader
}) => {
  const { styles } = useStyles();
  const switchLocaleDom = process.env.RUNTIME_ENV === "development" && /* @__PURE__ */ jsx(SwitchLocale, {});
  const userInfoDom = /* @__PURE__ */ jsx(UserInfo, { onEditPassword, onLogout });
  return /* @__PURE__ */ jsxs("div", { className: styles.wrapper, children: [
    /* @__PURE__ */ jsx("div", { className: styles.title, children: title }),
    /* @__PURE__ */ jsx(Space, { children: renderLayoutHeader ? renderLayoutHeader({
      userInfoDom,
      switchLocaleDom
    }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      switchLocaleDom,
      userInfoDom
    ] }) })
  ] });
};
var LayoutHeader_default = LayoutHeader;
export {
  LayoutHeader_default as default
};
